import * as THREE from 'three';
import Sizes from "./Utils/Sizes.js";
import Time from "./Utils/Time.js";
import Camera from './Camera.js';
import Renderer from './Renderer.js';
import World from './World/World.js';
import Resources from "./Utils/Resources.js";
import Sources from './Sources.js';
import DebugUI from './Utils/DebugUI.js';

let instance = null;

export default class LpApp
{
    constructor(canvas)
    {
        if(instance) { return instance; } // make this class a singleton
        instance = this;
        window.lpApp = this;
        this.Canvas = canvas;
        
        this.DebugUI = new DebugUI();
        this.Sizes = new Sizes();
        this.Time = new Time();
        this.Scene = new THREE.Scene();
        this.Resources = new Resources(Sources);
        this.Camera = new Camera();
        this.Renderer = new Renderer();
        this.World = new World();

        // attach event handlers
        this.Sizes.on('resize', () => { this.OnResize(); } );
        this.Time.on('tick', () => { this.Update(); } );

        console.log("Created LpApp.");
    }

    test() { console.log("testies ... 1 ... 2 ... 3 ???"); }

    OnResize()
    {
        // window has resized
        //console.log("LpApp.Resize(): callback for resize event.");
        this.Camera.Resize();
        this.Renderer.Resize();
    }

    Update()
    {
        //console.log("LpApp.Update(): callback for tick event.");
        this.Camera.Update();
        this.Renderer.Update();
        this.World.Update();
    }


    destroy()
    {
        this.Sizes.off('resize');
        this.Time.off('tick');

        this.Scene.traverse((child) =>
        {
            //console.log(child);
            if(child instanceof THREE.Mesh)
            {
                child.geometry.dispose();
            }

            for(const key in child.material)
            {
                //console.log(child.material[key]);

                // check each property of material and call dispose() if it has it
                const property = child.material[key];

                if(property && typeof property.dispose === 'function')
                {
                    property.dispose();
                }

            }
        });

        this.Camera.controls.dispose();
        this.Renderer.Instance.dispose();

        //if(this.DebugUI.active)
        //    this.DebugUI.ui.dispose();
    }

}